import { z } from 'zod';
// ─── Константы ───────────────────────────────────────────────────────────────
/** Разрешённый набор emoji-реакций (курируемый — произвольный ввод не принимаем). */
export const REACTION_EMOJIS = [
    // Жесты и одобрение
    '👍', '👎', '👏', '🙌', '🙏', '🤝', '💪', '🫡', '🤙', '✌️',
    // Сердца и позитив
    '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '💯', '🔥', '⚡',
    // Лица — радость
    '😄', '😁', '😂', '🤣', '🙂', '😊', '😍', '🤩', '😎', '🥳',
    // Лица — реакции
    '🤔', '😐', '😕', '🙃', '😳', '🤯', '😮', '😱', '😴', '🥱',
    // Лица — негатив/эмоции
    '😅', '😬', '😢', '😭', '😡', '🤨', '🫢', '🤮',
    // Празднование и символы
    '🎉', '🎊', '🚀', '⭐', '🌟', '✨', '💡', '🎯', '👀', '🫶',
    // Статусы
    '✅', '❌', '⚠️', '❓', '❗', '➕',
    // Странное и весёлое
    '💩', '🤡', '👻', '💀', '☠️', '👽', '👾', '🤖', '🎃', '🙈',
    '🙉', '🙊', '🦄', '🐸', '🌈', '🍕', '🍺', '☕', '🧠', '👑',
    '🫠', '🥴', '🤪', '😈', '🤓', '🥺', '🤠', '🫥', '🗿', '🥲',
];
/** Максимум разных реакций от одного пользователя на один target (карточку/коммент). */
export const MAX_REACTIONS_PER_USER = 3;
// ─── Request schemas ────────────────────────────────────────────────────────
export const AddReactionRequestSchema = z.object({
    emoji: z.enum(REACTION_EMOJIS),
});
// ─── Response schemas ───────────────────────────────────────────────────────
/** Агрегат по одной emoji на target: сколько реакций, кто (человекочитаемо) и
 *  поставил ли текущий пользователь. */
export const ReactionSummarySchema = z.object({
    emoji: z.string(),
    count: z.number().int().nonnegative(),
    /** id пользователей, поставивших эту emoji (для дедупа/логики). */
    userIds: z.array(z.string().uuid()),
    /** ФИО пользователей для тултипа (в том же порядке, что userIds). */
    userNames: z.array(z.string()),
    /** Поставил ли текущий пользователь именно эту emoji. */
    reactedByMe: z.boolean(),
});
export const ReactionListResponseSchema = z.object({
    reactions: z.array(ReactionSummarySchema),
});
